<template>
  <Sheet>
    <template #leading>
      <Sheet.Button :icon="CloseIcon" @click="close()" />
    </template>
    <template #title>Billing</template>

    <Sheet.Body>
      <SelectPlanBillingBody :plans="plans" />
    </Sheet.Body>
  </Sheet>
</template>

<script setup lang="ts">
import { Sheet, useSheet } from '@dacr/library'
import { CloseIcon } from '@dacr/icons'

import type { Plan } from '@/shared/graphql/legacy/generated'
import SelectPlanBillingBody from './SelectPlanBillingBody.vue'

defineProps<{
  plans: Plan[]
}>()

const { close } = useSheet()
</script>
